//import 'babel-polyfill';
import './scss/front.scss';
import './js/site-legacy';
import './js/layout/header';